import React from 'react';
import { IReceptionListItemProps } from './types';
import {
  VisitorCard,
  AvatarColumn,
  DetailsColumn,
  Avatar,
  VisitorName,
  CompanyName,
  BadgeContainer,
  Badge,
  CarRegistration,
} from './ReceptionList.styled';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ReceptionMobileListItem = React.memo<IReceptionListItemProps>(
  ({ visitor, signedOut, isSigningOut, onClick, onSignOut }) => {
    return (
      <VisitorCard signedOut={signedOut} onClick={onClick}>
        <AvatarColumn>
          <Avatar>
            <FontAwesomeIcon icon={visitor.visitorType.icon} size="3x" />
          </Avatar>
          <small className="d-block mt-3">
            <FontAwesomeIcon icon={['far', 'arrow-right']} />{' '}
            {visitor.inAt.toLocaleTimeString('en-GB', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })}
          </small>
          {signedOut && (
            <small className="d-block">
              <FontAwesomeIcon icon={['far', 'arrow-left']} />{' '}
              {visitor.outAt!.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })}
            </small>
          )}
          <CarRegistration>{visitor.carRegistration}</CarRegistration>
        </AvatarColumn>
        <DetailsColumn>
          <div>
            <VisitorName>
              {visitor.firstNames} {visitor.surname}
            </VisitorName>
            <CompanyName>{visitor.company}</CompanyName>
            <div>To see {visitor.host}</div>
          </div>
          <div>
            {isSigningOut ? (
              <span>...</span>
            ) : (
              !signedOut && (
                <Button
                  className="w-100"
                  type="button"
                  variant="danger"
                  size="sm"
                  onClick={(event: React.SyntheticEvent) => {
                    event.stopPropagation();
                    onSignOut();
                  }}
                >
                  Sign Out
                  {visitor.badgeDescription?.length > 0 &&
                    ` - ${visitor.badgeDescription}`}
                </Button>
              )
            )}
          </div>
          <BadgeContainer>
            {visitor.carRegistration && (
              <Badge>
                <FontAwesomeIcon icon="car" />
              </Badge>
            )}
            {visitor.mobile && (
              <Badge>
                <FontAwesomeIcon icon="phone" />
              </Badge>
            )}
            {visitor.emailAddress && (
              <Badge>
                <FontAwesomeIcon icon="envelope" />
              </Badge>
            )}
            {visitor.triggeredQuestionnaireAlert && (
              <Badge>
                <FontAwesomeIcon
                  icon="exclamation-triangle"
                  className="text-warning"
                />
              </Badge>
            )}
          </BadgeContainer>
        </DetailsColumn>
      </VisitorCard>
    );
  },
);
